import React from 'react';
import Moment from 'moment';
import { DateRangePicker } from 'react-dates';
import Overlay from 'Components/Overlay';
import Cx from 'classnames';

const ExtendContratTenure = (props) => {
    const { contractTenureFrom, contractTenureTo } = props.CTData;

    return (

        <Overlay>
            <div className="bg-white box-shadow ph-20 pv-20 br-5">
                <div className={"mb-10 tCenter fSemibold header-medium-color fs-18"}>
                    Extend Contract Tenure
                </div>
                <div className={Cx('',{
                    'ht-400 wt-600': props.focusedInput
                })}>
                    <DateRangePicker
                        startDate={contractTenureTo ? Moment(contractTenureFrom || null) : Moment(contractTenureFrom)}
                        startDateId="startDate"
                        endDate={contractTenureTo ? Moment(contractTenureTo) : null}
                        endDateId="endDate"
                        onDatesChange={props.onChange}
                        focusedInput={props.focusedInput}
                        onFocusChange={props.onFocusChange}
                        displayFormat={'DD MMM YYYY'}
                        noBorder={true}
                        minimumNights={0}
                    />
                </div>
                <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>
                    <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30"  onClick={props.onSave}>Save</button>
                </div>
            </div>
        </Overlay>
    )
}

export default ExtendContratTenure;